import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismCheckbox, PrismTooltip } from '@mylighthouse/prism-ember';
import dayjs from 'dayjs';
import { t } from 'ember-intl';
import GeneralIconWithTooltip from 'lumen/components/general/icon-with-tooltip';

interface SettingsMappingTableCellCheckboxMappingCellCheckboxMappingBenchmarkSignature {
  Args: {
    column: unknown;
    row: unknown;
    value: unknown;
  };
}

export default class SettingsMappingTableCellCheckboxMappingCellCheckboxMappingBenchmark extends Component<SettingsMappingTableCellCheckboxMappingCellCheckboxMappingBenchmarkSignature> {
  @service declare intl: Services['intl'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get iconName() {
    const pmsMappingValue = this.args.row;
    let iconValue;
    // @ts-expect-error: Incorrect type
    if (pmsMappingValue.readOnly) {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
      const reasonCode = pmsMappingValue.readOnlyReason.code;

      switch (reasonCode) {
        case 'chain_mapping':
          iconValue = 'lock';
          break;
        case 'recently_changed':
          iconValue = 'clock';
          break;
        default:
          iconValue = 'lock';
      }
    }
    return iconValue;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isDisabled() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this.args.column.isDisabled || this.args.column.isMappingDisabled;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isLocked() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this.args.row.readOnly;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get tooltipContent() {
    const pmsMappingValue = this.args.row;

    // @ts-expect-error: Incorrect type
    if (!pmsMappingValue.readOnly) {
      return '';
    }

    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    const reasonCode = pmsMappingValue.readOnlyReason.code;
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    const reasonValue = pmsMappingValue.readOnlyReason.arg;

    switch (reasonCode) {
      case 'chain_mapping':
      case 'chain_mapping__market_code': {
        return this.intl.t(
          'settings.pms_mapping.tooltip.brand_mapping_lock_reason',
          {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            chain: reasonValue,
          },
        );
      }

      case 'recently_changed': {
        return this.intl.t('settings.pms_mapping.tooltip.timer_lock_reason', {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
          date: dayjs(reasonValue).format('LL'),
        });
      }

      default: {
        return '';
      }
    }
  }

  @action
  // @ts-expect-error: Incorrect type
  onChangeValue(event): void {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    this.args.column.setRowSelection(this.args.row, event.target.checked);
  }

  <template>
    <div class="flex justify-start">
      {{#if this.isLocked}}
        <div class="ml-50">
          <GeneralIconWithTooltip
            {{! @glint-expect-error: Incorrect type }}
            @iconName={{this.iconName}}
            @side="top"
            @tooltipContent={{this.tooltipContent}}
          />
        </div>
      {{else}}
        <PrismCheckbox
          {{! @glint-expect-error: Incorrect type }}
          @checked={{@value}}
          @disabled={{this.isDisabled}}
          @onChange={{this.onChangeValue}}
          data-test-id="checkbox-mapping"
        />
        {{! @glint-expect-error: Incorrect type }}
        {{#if @column.isMappingDisabled}}
          <PrismTooltip
            {{! @glint-expect-error: Incorrect type }}
            @text={{@column.mappingDisabledTooltipText}}
            @title={{t
              "benchmark_insight.pms_mapping.tooltip.read_only_view.title"
            }}
          />
        {{/if}}
      {{/if}}
    </div>
  </template>
}
